const banks = [
  { text: 'ABSA', value: 'ABSA' },
  { text: 'African Bank', value: 'AFRICAN_BANK' },
  { text: 'Bidvest Bank', value: 'BIDVEST_BANK' },
  { text: 'Capitec', value: 'CAPITEC' },
  { text: 'Discovery Bank', value: 'DISCOVERY_BANK' },
  { text: 'FNB', value: 'FNB' },
  { text: 'Investec', value: 'INVESTEC' },
  { text: 'Ithala', value: 'ITHALA' },
  { text: 'Nedbank', value: 'NEDBANK' },
  { text: 'Old Mutual', value: 'OLD_MUTUAL' },
  { text: 'Post Bank', value: 'POST_BANK' },
  { text: 'Standard Bank', value: 'STANDARD_BANK' },
  { text: 'Tyme Bank', value: 'TYME_BANK' },
];

const educationLevels = [
  { text: 'No matric', value: 'NO_MATRIC' },
  { text: 'Matric', value: 'MATRIC' },
  { text: '3 year degree/diploma', value: 'THREE_YEAR_DEGREE' },
  { text: '4 year degree', value: 'FOUR_YEAR_DEGREE' },
  { text: 'Professional', value: 'PROFESSIONAL' },
];

const insuranceQuestionEducationLevels = [
  { text: 'No matric', value: 'NO_MATRIC' },
  { text: 'Matric', value: 'MATRIC' },
  { text: '3 Year Diploma', value: 'THREE_YEAR_DIPLOMA' },
  { text: '4 Year Diploma', value: 'FOUR_YEAR_DIPLOMA' },
  { text: '3 Year Degree', value: 'THREE_YEAR_DEGREE' },
  { text: '4 Year Degree', value: 'FOUR_YEAR_DEGREE' },
  { text: 'Postgraduate', value: 'POSTGRADUATE' },
];

export { banks, educationLevels, insuranceQuestionEducationLevels };
